import { styled } from '@/styled-system/jsx';

export const DarkText = styled('span', {
  base: {
    color: 'hpxGrey600',
  },
});

export const Header = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1x',
    padding: '2x',
    borderWidth: '0px 0px 1px 0px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey400',
  },
});

export const SendIcon = styled('img', {
  base: {
    width: '24px',
    height: '24px',
  },
});
